<template>
  <div>
    <el-table :data="userList" style="width: 100%" height="calc(100vh - 375px)" :render-header="renderHeader"
      class="table-fixed" ref="multipleTable" @sort-change="handleSort" :row-class-name="tableRowClassName"
      :default-sort="{ prop: 'openTime', order: 'descending' }">
      <el-table-column label="仓位类型" align="center" min-width="100"><template slot-scope="scope">{{ formatPositionCategory(scope.row) }}</template></el-table-column>
      <!-- <el-table-column label="订单ID" align="center">
        <template slot-scope="scope">{{ scope.row.id }}</template>
</el-table-column> -->

      <el-table-column label="用户ID" align="center" min-width="160" fixed="left">
        <template slot-scope="scope"><span @click="showBox(scope.row, 2)" :class="{
          tdRed: scope.row.mark == true,
          blue: scope.row.mark != true,
          myTd: true,
        }">
            {{ scope.row.userId }}</span></template>
      </el-table-column>
      <el-table-column prop="userTypeName" label="用户类型" align="center" min-width="120" fixed="left" />
      <el-table-column prop="channelUserId" label="合伙人UID" align="center" fixed="left" min-width="160">
        <template slot-scope="scope">
          <span @click="showBox(scope.row, 1)" class="myTd blue">{{
            scope.row.channelUserId
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="topUserId" label="顶级合伙人UID" align="center" min-width="160" fixed="left">
      </el-table-column>
      <el-table-column prop="id" label="仓位ID" align="center" min-width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.positionId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="symbol" label="合约名称" align="center" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.symbol }}
        </template>
      </el-table-column>
      <el-table-column label="杠杆" align="center" min-width="100" sortable="custom" prop="leverage">
        <template slot-scope="scope">{{ scope.row.leverage }}</template>
      </el-table-column>
      <el-table-column label="买卖方向" align="center" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.positionSide == 1" :style="{
            color: '#03ad79',
          }">开多</span>
          <span v-else :style="{
            color: ' #EC6D56',
          }">开空</span>
        </template>
      </el-table-column>

      <el-table-column label="持仓数量" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.positionSize }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手续费(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.unsettledProfit }}</span>
        </template>
      </el-table-column>
      <el-table-column label="保证金(₮)" align="center" min-width="160" sortable="custom" prop="openOrderMarginFrozen">
        <template slot-scope="scope">
          <span>{{ scope.row.openOrderMarginFrozen }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开仓均价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.entryPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="未结算盈亏(₮)" align="center" :render-header="renderHeader" width="160" prop="unsettledGains"
        sortable="custom">
        <template slot-scope="scope">
          <span>{{ scope.row.unsettledGains }}</span>
        </template>
      </el-table-column>
      <el-table-column label="已结算盈亏(₮)" align="center" :render-header="renderHeader" min-width="160">
        <template slot-scope="scope">
          <el-button type="text" @click="showOrder(scope.row)">{{
            scope.row.settledGains
          }}</el-button>
        </template>
      </el-table-column>

      <!-- <el-table-column label="收益率" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.incomeRate }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="预估强平价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.forceClosePrice >= 0">{{
            scope.row.forceClosePrice
          }}</span>
          <span v-if="scope.row.forceClosePrice < 0">--</span>
        </template>
      </el-table-column>

      <el-table-column label="实际强平价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.realForcePrice || '--' }}</span> -->
          <span v-if="scope.row.realForcePrice >= 0">{{
            scope.row.realForcePrice
          }}</span>
          <span v-if="scope.row.realForcePrice < 0">--</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="止盈价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.triggerProfitPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column label="止损价(₮)" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.triggerStopPrice }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="止盈价(₮) / 数量" align="center" min-width="160">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.triggerProfitPrice }}</span> -->
          <div v-for="(item, i) in scope.row.triggerProfitPrice
            ? scope.row.triggerProfitPrice
            : []" :key="i">
            {{ item.split('/')[0] }}/{{ item.split('/')[1] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="止损价(₮) / 数量" align="center" min-width="160">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.triggerStopPrice }}</span> -->
          <div v-for="(item, i) in scope.row.triggerStopPrice
            ? scope.row.triggerStopPrice
            : []" :key="i">
            {{ item.split('/')[0] }}/{{ item.split('/')[1] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="风险度" align="center" sortable="custom" width="120" prop="riskRate">
        <template slot-scope="scope">
          <span>{{ scope.row.riskRate }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="持仓价值" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.totalAmount }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="仓位类型" align="center" min-width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.positionType == 1">全仓</span>
          <span v-else>逐仓</span>
        </template>
      </el-table-column>
      <el-table-column label="开仓时间" align="right" min-width="160" prop="openTime" sortable="custom"
        :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ scope.row.openTime | moment }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="mini" @click="goDetail(scope.row)">资产明细</el-button>
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)" v-if="scope.row.type == 0">修改备注</el-button> -->
          <el-button v-if="!isCustom" type="text" size="mini" @click="closeOut(scope.row)">平仓</el-button>
          <el-button v-if="!isCustom" size="mini" type="text" @click="blasting(scope.row)">爆仓</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>
    <!-- <update-dialog
      :val="userinfoDetail"
      :updateForm="updateForm"
    ></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog title="修改备注" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input type="textarea" :rows="5" placeholder="请输入备注信息" maxlength="50" show-word-limit
              v-model="textarea2">
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add">添 加</el-button>
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>

    <el-dialog title="平仓" :visible="closeOutVisible" width="30%" center :show-close="false">
      <div class="main">
        <div class="items">
          <span>合伙人UID：</span>
          <span>{{ closeOutObj.channelUserId }}</span>
        </div>
        <div class="items">
          <span>用户ID：</span>
          <span>{{ closeOutObj.userId }}</span>
        </div>
        <div class="items">
          <span>仓位ID：</span>
          <span>{{ closeOutObj.positionId }}</span>
        </div>
        <div class="items">
          <span>合约名称：</span>
          <span>{{ closeOutObj.symbol }}</span>
        </div>
        <div class="items">
          <span>杠杆：</span>
          <span>{{ closeOutObj.leverage }}</span>
        </div>
        <div class="items">
          <span>买卖方向：</span>
          <span v-if="closeOutObj.positionSide == 1" :style="{
            color: '#03ad79',
          }">开多</span>
          <span v-else :style="{
            color: ' #EC6D56',
          }">开空</span>
        </div>
        <div class="items">
          <span>持仓数量：</span>
          <span>{{ closeOutObj.positionSize }}</span>
        </div>
        <div class="items">
          <span>手续费：</span>
          <span>{{ closeOutObj.unsettledProfit }}</span>
        </div>
        <div class="items">
          <span>保证金：</span>
          <span>{{ closeOutObj.openOrderMarginFrozen }}</span>
        </div>
        <div class="items">
          <span>开仓均价：</span>
          <span>{{ closeOutObj.entryPrice }}</span>
        </div>
        <div class="items">
          <span>未结算盈亏：</span>
          <span>{{ closeOutObj.unsettledGains }}</span>
        </div>
        <div class="items">
          <span>仓位类型：</span>
          <span v-if="closeOutObj.positionType == 1">全仓</span>
          <span v-else>逐仓</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOutVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeOutSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="爆仓" :visible="blastingVisible" width="80%" center :show-close="false">
      <div class="main">
        <el-table :data="dialogTabList" class="table-fixed" height="300px">
          <el-table-column prop="positionId" label="仓位ID" align="center" fixed="left" min-width="180" />
          <el-table-column prop="symbol" label="合约名称" align="center" />
          <el-table-column label="杠杆" prop="leverage" align="center" />
          <el-table-column label="仓位类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.positionType == 1">全仓</span>
              <span v-else>逐仓</span>
            </template>
          </el-table-column>
          <el-table-column label="仓位方向" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.positionSide == 1">多</span>
              <span v-if="scope.row.positionSide == 2">空</span>
            </template>
          </el-table-column>
          <el-table-column label="仓位数量" prop="positionSize" align="center" />
          <el-table-column label="开仓均价" prop="entryPrice" align="center" />
          <el-table-column label="爆仓价格" align="center" fixed="right">
            <template slot-scope="scope">
              <el-input clearable v-model="scope.row.takeoverPrice" class="userUid_ipt">
              </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blastingVisible = false">取 消</el-button>
        <el-button type="primary" @click="blastingSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单记录" :visible="orderVisible" width="80%" center :show-close="false">
      <div class="main">
        <el-table :data="orderList" class="table-fixed" height="300px">
          <el-table-column prop="userId" label="用户ID" align="center" min-width="120" />
          <el-table-column label="订单ID" prop="orderId" align="center" min-width="160" />
          <el-table-column label="合伙人ID" prop="channelUserId" align="center" min-width="120" />
          <el-table-column label="合约名" prop="symbol" align="center" />
          <el-table-column label="方向" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.orderSide == 1 && scope.row.positionSide == 1">买入开多
              </span>
              <span class="red" v-if="scope.row.orderSide == 1 && scope.row.positionSide == 2">买入平空</span>
              <span class="green" v-if="scope.row.orderSide == 2 && scope.row.positionSide == 1">卖出平多
              </span>
              <span class="red" v-if="scope.row.orderSide == 2 && scope.row.positionSide == 2">卖出开空</span>
            </template>
          </el-table-column>
          <el-table-column label="平仓盈亏" prop="profit" align="center" />
          <el-table-column label="开/平仓价格" prop="price" align="center" />
          <el-table-column label="开/平仓数量" prop="origQty" align="center" min-width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.origQty }}</span>&nbsp;<span v-if="scope.row.symbol">{{
                transform(scope.row.symbol)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.orderType == 1">限价</span>
              <span v-if="scope.row.orderType == 2">市价</span>
            </template>
          </el-table-column>
          <el-table-column label="杠杆倍数" prop="leverage" align="center" />
          <el-table-column label="触发类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceType == 5">移动止盈止损</span>
              <span v-else-if="scope.row.sourceType == 2">止盈止损</span>
              <span v-else-if="scope.row.sourceType == 3012">爆仓</span>
              <span v-else>普通订单</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.updatedTime | moment }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination :size="orderPage.size" :total="orderTotal" :page="orderPage.page" @pageChanged="orderPageChanged">
        </pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colseOrder">取 消</el-button>
      </span>
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import api from '../../api'
import UserDetailDialog from 'components/userDetailDialog'
import { positionOrderList } from '@/common/publicApi'
import { formatPositionCategory } from '../../../positionCategory'
export default {
  name: 'UserList',
  data() {
    return {
      updateForm: {},
      centerDialogVisible: false,
      textarea2: '',
      closeOutVisible: false,
      blastingVisible: false,
      closeOutObj: {},
      dialogTabList: [],
      userId: '',
      type: '',
      id: '',
      orderVisible: false,
      orderList: [],
      orderPage: {
        page: 1,
        size: 10,
      },
      orderTotal: 0,
    }
  },
  watch: {
    userList: {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true,
    },
  },
  components: {
    Pagination,
    updateDialog,
    UserDetailDialog,
  },
  methods: {
    formatPositionCategory,
    ...mapActions('contractPosition', ['addRemark']),
    ...mapMutations('contractPosition', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setUserList',
      'setOrderBy',
    ]),
    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    renderHeader(h, { column, $index }) {
      // 新建一个 span
      let span = document.createElement('span')
      // 设置表头名称
      span.innerText = column.label
      // 临时插入 document
      document.body.appendChild(span)
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20
      // 移除 document 中临时的 span
      document.body.removeChild(span)
      return h('span', column.label)
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row) {
      this.updateForm = row
      // this.setUserinfoDetail(row);
      // this.setUserinfoDetailDialogVisible(true);
      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
            ; (this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    goDetail(row) {
      this.$router.push({ path: `/home/contractPosition/detail`, query: row })
    },
    closeOut(row) {
      this.closeOutObj = row
      this.closeOutVisible = true
    },
    blasting(row) {
      this.dialogTabList = []
      api
        .getPosition({ accountId: row.userId, positionId: row.positionId })
        .then((res) => {
          if (res.code == 0) {
            this.blastingVisible = true
            this.dialogTabList = res.data
          }
        })
    },
    closeOutSubmit() {
      api
        .fixClosePosition({
          accountId: this.closeOutObj.userId,
          positionId: this.closeOutObj.positionId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.closeOutVisible = false
            this.$message.success('操作成功！')
            this.$emit('refresh')
          }
        })
    },
    blastingSubmit() {
      let flag = this.dialogTabList.every((i) => i.takeoverPrice)
      if (!flag) {
        return this.$message.error('请输入爆仓价格！')
      }
      let arr = []
      this.dialogTabList.forEach((i) => {
        arr.push({
          positionId: i.positionId,
          accountId: i.accountId,
          takeoverPrice: i.takeoverPrice,
        })
      })
      api.takeOverPosition(arr).then((res) => {
        if (res.code == 0) {
          setTimeout(() => {
            this.$message.success('操作成功！')
            this.$emit('refresh')
            this.blastingVisible = false
          }, 2000)
        }
      })
    },
    showBox(row, type) {
      this.type = type
      this.id = type == 2 ? row.userId : row.channelUserId
      this.setUserDetailInfoVisible(true)
    },

    sortOpenOrderMarginFrozen(a, b) {
      return Number(a.openOrderMarginFrozen) - Number(b.openOrderMarginFrozen)
    },

    getOrderList() {
      positionOrderList({
        positionId: this.closeOutObj.positionId,
        ...this.orderPage,
      }).then((res) => {
        if (res.code == 0) {
          this.orderList = res.data.list
          this.orderTotal = res.data.totalCount
        }
      })
    },
    colseOrder() {
      this.closeOutObj = {}
      this.orderPage = {
        page: 1,
        size: 10,
      }
      this.orderTotal = 0
      this.orderVisible = false
    },
    showOrder(row) {
      this.closeOutObj = row
      this.orderVisible = true
      this.getOrderList()
    },
    orderPageChanged(pagination) {
      this.orderPage = pagination
      this.getOrderList()
    },
    transform(str) {
      if (str) {
        return str.split('_')[0].toUpperCase()
      }
      return ''
    },
    sortUnsettledGains(a, b) {
      return Number(a.unsettledGains) - Number(b.unsettledGains)
    },

    handleSort({ column, prop, order }) {
      // if (column.property === 'unsettledGains') {
      //   return
      // }
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },

    tableRowClassName({ row }) {
      if (row.mark == true) {
        return 'redRow'
      }
      return ''
    },
  },
  beforeDestroy() {
    this.setUserList({ list: [] })
  },

  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('contractPosition', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'orderBy',
    ]),
    isCustom() {
      let flag = false
      this.userInfo.roles
        ? (flag = this.userInfo.roles.some(
          (item) => item.productId == 5 && item.name === '客服'
        ))
        : (flag = true)
      return flag
    },
  },
}
</script>

<style lang="less" src="../../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.items {
  margin-top: 4px;
  display: flex;
  gap: 20px;
}

.green {
  color: skyblue;
}

.red {
  color: #f54a45;
}
</style>
